import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { Accordion } from 'primereact/accordion';

export const StyledDescription = styled.div<{ color: string }>`
    background: ${({ color }) =>
        color
            ? `#${color}AA;`
            : `linear-gradient(270deg,rgba(251, 63, 248, 1) 0%, rgba(252, 197, 70, 1) 100%);`}
    width: ${rem(300)};
    text-align: center;
    padding: ${rem(16)};
    margin-bottom: ${rem(4)};
`;

export const ApplicantTagsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(12)};
`;

export const JourneyWrapper = styled.div`
    margin-left: ${rem(16)};
`;

export const ReasonCodesWrapper = styled.div`
    flex: 1;
`;

export const StyledAccordion = styled(Accordion)`
    flex: 1;

    .p-accordion-header a {
        height: ${rem(48)};
        background: #f8fafc;
        border-color: #e2e8f0;
        color: #334155;
    }

    .p-accordion-header a:hover {
        background: #f1f5f9;
    }

    a {
        font-size: ${rem(12)};
        display: flex;
        flex-direction: row-reverse;
    }
    p {
        font-size: ${rem(12)};
    }
`;

export const AccordionIcon = styled.i`
    font-size: ${rem(10)};
    padding: ${rem(4)};
    border-radius: 50%;
    background-color: #00000020;
`;

export const AccordionTabWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
`;

export const AccordionTabContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(8)};
    background: #f1f5f9;
    border-radius: ${rem(8)};
    padding: 0 ${rem(8)};
`;

export const ReasonCode = styled.label`
    padding: ${rem(4)};
    font-size: ${rem(12)};
    border: 1px solid;
    border-radius: ${rem(4)};
`;

export const TagsAndWatchlistLayout = styled.div`
    display: flex;
    gap: ${rem(24)};
    align-items: flex-start;
    margin-top: ${rem(16)};

    & > * {
        flex: 1;
        min-width: 0;
    }
`;

// Card shell, header bar and title follow the DDD card (DDDCard / DDDCardHeader / DDDCardTitle).
export const SectionCard = styled.div`
    background: #ffffff;
    border-radius: ${rem(10)};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;
`;

export const SectionCardTitle = styled.h3`
    margin: 0;
    padding: ${rem(12)} ${rem(20)};
    background: #f1f5f9;
    border-bottom: 1px solid #e2e8f0;
    color: #334155;
    font-size: ${rem(17)};
    font-weight: 600;
`;

export const SectionCardBody = styled.div`
    padding: ${rem(16)} ${rem(20)};
`;
